import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaAward, FaUsers, FaClock, FaCheckCircle, FaHandshake, FaTools } from 'react-icons/fa';
import './AboutPage.css';
import mainLogo from '../images/main-logo-img.jpeg'

const About = () => {
  const values = [
    {
      icon: <FaHandshake />,
      title: 'Integrity',
      description: 'We conduct business with honesty and transparency, building trust with our clients.'
    },
    {
      icon: <FaAward />,
      title: 'Excellence',
      description: 'We strive for excellence in every project, maintaining the highest quality standards.'
    },
    {
      icon: <FaUsers />,
      title: 'Customer First',
      description: 'Your satisfaction is our top priority. We listen and respond to your needs.'
    },
    {
      icon: <FaTools />,
      title: 'Innovation',
      description: 'We use the latest techniques and equipment to deliver superior results.'
    }
  ];

  const milestones = [
    { year: '2018', title: 'Company Founded', description: 'Started with a small team and big dreams' },
    { year: '2020', title: '100 Projects', description: 'Reached our first major milestone' },
    { year: '2022', title: 'Expansion', description: 'Expanded services to cover entire region' },
    { year: '2024', title: '500+ Projects', description: 'Celebrated 500 successful projects' },
    { year: '2026', title: 'Industry Leader', description: 'Recognized as a trusted service provider' }
  ];

  const stats = [
    { number: '500+', label: 'Projects Completed', icon: <FaCheckCircle /> },
    { number: '10+', label: 'Years Experience', icon: <FaClock /> },
    { number: '200+', label: 'Happy Clients', icon: <FaUsers /> },
    { number: '50+', label: 'Expert Team', icon: <FaAward /> }
  ];

  return (
    <div className="about-page">
      {/* Page Hero */}
      <section className="page-hero about-hero">
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <span className="page-badge">About Us</span>
              <h1 className="page-title">Your Trusted Service Partner</h1>
              <p className="page-description">
                With over 10 years of experience, we have built a reputation for excellence, 
                reliability, and customer satisfaction in the service industry.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Company Story */}
      <section className="company-story-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="story-content">
                <span className="section-badge">Our Story</span>
                <h2 className="section-title">Building Trust Through Excellence</h2>
                <p className="story-text">
                  OM SHAKTI GOOD SERVICES was founded with a simple mission: to provide 
                  exceptional service quality and customer satisfaction. What started as a 
                  small local business has grown into a trusted service provider serving 
                  clients across the region.
                </p>
                <p className="story-text">
                  Our journey has been built on the foundation of hard work, dedication, 
                  and an unwavering commitment to quality. We believe that every project, 
                  no matter how big or small, deserves our best effort and attention to detail.
                </p>
                <p className="story-text">
                  Today, we continue to evolve and improve, adopting new technologies and 
                  techniques while maintaining our core values of integrity, excellence, 
                  and customer-first service.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="story-image-wrapper">
                <div className="story-image">
                  {/* <div className="image-placeholder"> */}
                    <img className='w-100' src={mainLogo} alt="Om  Shakti Good Services"/>
                    {/* <FaTools className="placeholder-icon" />
                    <p>Company Photo</p> */}
                  {/* </div> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="about-stats-section">
        <Container>
          <Row className="g-4">
            {stats.map((stat, index) => (
              <Col key={index} lg={3} md={6}>
                <Card className="stat-card-about">
                  <Card.Body className="text-center p-4">
                    <div className="stat-icon-about">{stat.icon}</div>
                    <h3 className="stat-number-about">{stat.number}</h3>
                    <p className="stat-label-about">{stat.label}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5">
              <span className="section-badge">Our Values</span>
              <h2 className="section-title">What We Stand For</h2>
              <p className="section-subtitle">
                Our core values guide everything we do and shape how we serve our clients
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            {values.map((value, index) => (
              <Col key={index} lg={3} md={6}>
                <Card className="value-card h-100">
                  <Card.Body className="text-center p-4">
                    <div className="value-icon">{value.icon}</div>
                    <Card.Title className="value-title">{value.title}</Card.Title>
                    <Card.Text className="value-description">{value.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5">
              <span className="section-badge">Our Journey</span>
              <h2 className="section-title">Milestones & Achievements</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="timeline">
                {milestones.map((milestone, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-year">{milestone.year}</div>
                    <div className="timeline-content">
                      <h4 className="timeline-title">{milestone.title}</h4>
                      <p className="timeline-description">{milestone.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="about-cta-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 className="cta-title">Ready to Work With Us?</h2>
              <p className="cta-description">
                Experience the difference of working with a trusted, experienced service provider. 
                Contact us today to discuss your project.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <Link href='tel:+919560424647' className="cta-button-link">
                Get In Touch
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default About;

